{
  "Your Stripe account, your branding, your price": "Twoje konto Stripe, twój branding, twoja cena",
  "Our fee is just US $1.50 per ticket sold (introductory offer)": "Nasza opłata to tylko 1,50 USD za sprzedany bilet (oferta promocyjna na start)",
  "All countries and 31 currencies supported": "Obsługa wszystkich krajów i 31 walut",
  "A fixed price, or let buyers choose the price": "Stała cena albo pozwól kupującym wybrać cenę",
  "Coupons and other Stripe features": "Kupony i inne funkcje Stripe",
  "Currency": "Waluta",
  "Loading currencies…": "Wczytywanie walut…",
  "Amount": "Kwota",
  "Fee": "Opłata",
  "{code} - {name} (No auto-conversion)": "{code} - {name} (bez automatycznego przeliczania)",
  "Search currency...": "Szukaj waluty...",
  "Add currency": "Dodaj walutę",
  "Single day {price} (24h access)": "Jeden dzień {price} (dostęp na 24 godziny)",
  "All {days} days {price}": "Wszystkie {days} dni {price}",
  "Livestream {price} (no replay)": "Transmisja na żywo {price} (bez nagrania)",
  "Livestream {price}": "Transmisja na żywo {price}",
  "Livestream + Replay {price}": "Transmisja na żywo + nagranie {price}",
  "+ video download add-on {price}": "+ dodatkowo wideo do pobrania {price}",
  "+ service & processing fee at checkout": "+ opłata serwisowa i transakcyjna przy płatności",
  "Video download {price} (live-only event — no replay)": "Wideo do pobrania {price} (wydarzenie tylko na żywo — bez nagrania)",
  "Nothing (live-only event with downloads off)": "Nic (wydarzenie tylko na żywo, pobieranie wyłączone)",
  "Replay {price}": "Nagranie {price}",
  "Replay + download": "Nagranie + pobieranie",
  "What buyers will see": "Co zobaczą kupujący",
  "Before & during the event: {items}": "Przed wydarzeniem i w trakcie: {items}",
  "After the event: {items}": "Po wydarzeniu: {items}",
  "Unlink Stripe Account": "Odłącz konto Stripe",
  "Are you sure you want to unlink your Stripe account? This will disable ticket sales for this event.": "Czy na pewno chcesz odłączyć konto Stripe? Sprzedaż biletów na to wydarzenie zostanie wyłączona.",
  "Failed to unlink Stripe account. Please try again.": "Nie udało się odłączyć konta Stripe. Spróbuj ponownie.",
  "Sell tickets": "Sprzedawaj bilety",
  "Couldn't load currencies": "Nie udało się wczytać walut",
  "Check your connection and try again.": "Sprawdź połączenie i spróbuj ponownie.",
  "Guests pay to watch, and the money goes straight to your Stripe account.": "Goście płacą za oglądanie, a pieniądze trafiają prosto na twoje konto Stripe.",
  "Tickets for rooms": "Bilety na sale",
  "Connect Stripe account": "Połącz konto Stripe",
  "Copy link to connect Stripe": "Kopiuj link do połączenia ze Stripe",
  "Send it to the Stripe account's owner.": "Wyślij go właścicielowi konta Stripe.",
  "Not your Stripe account? Send the link to its owner so they can connect it.": "To nie twoje konto Stripe? Wyślij link jego właścicielowi – połączy je samodzielnie.",
  "Stripe fees, refunds and chargebacks are the connected account holder's responsibility. Need help setting up? Ask us in the support chat.": "Za opłaty Stripe, zwroty i obciążenia zwrotne odpowiada właściciel połączonego konta. Potrzebujesz pomocy z konfiguracją? Zapytaj nas na czacie pomocy.",
  "Stripe account connected": "Połączono konto Stripe",
  "Stripe dashboard": "Panel Stripe",
  "Refresh": "Odśwież",
  "Unlink": "Odłącz",
  "How guests pay": "Jak płacą goście",
  "Disable Pay-Per-View": "Wyłącz pay-per-view",
  "Use Existing Stripe Price": "Użyj istniejącej ceny ze Stripe",
  "Custom Price (Fixed)": "Własna cena (stała)",
  "Customer Chooses Price": "Klient wybiera cenę",
  "Choose how guests pay": "Wybierz, jak płacą goście",
  "Select Stripe Price": "Wybierz cenę ze Stripe",
  "price|None": "Brak",
  "Custom Prices": "Własne ceny",
  "This event is live-only, so the ticket includes the livestream only (no replay).": "To wydarzenie jest tylko na żywo, więc bilet obejmuje wyłącznie transmisję na żywo (bez nagrania).",
  "The ticket includes the livestream.": "Bilet obejmuje transmisję na żywo.",
  "The ticket includes the livestream and the replay.": "Bilet obejmuje transmisję na żywo i nagranie.",
  "Set prices for each currency. First currency becomes the default.": "Ustaw ceny dla każdej waluty. Pierwsza waluta będzie domyślna.",
  "Sell single-day tickets": "Sprzedawaj bilety jednodniowe",
  "Your price above is the All-Days ticket. Set one price per day below — buyers choose which day. Single-day access lasts 24 hours from that day's scheduled start time.": "Cena powyżej dotyczy biletu na wszystkie dni. Poniżej ustaw cenę za jeden dzień — kupujący wybierają dzień. Dostęp jednodniowy trwa 24 godziny od zaplanowanej godziny rozpoczęcia danego dnia.",
  "Sell video download": "Sprzedawaj wideo do pobrania",
  "Buyers can add the downloadable video to any ticket for this amount.": "Kupujący mogą dodać wideo do pobrania do dowolnego biletu za tę kwotę.",
  "After the event it's sold on its own since this event is live-only.": "Po wydarzeniu jest sprzedawane osobno, ponieważ to wydarzenie jest tylko na żywo.",
  "After the event it's sold as Replay + Download.": "Po wydarzeniu jest sprzedawane jako „Nagranie + pobieranie”.",
  "Single-day buyers can only download their day.": "Osoby z biletem jednodniowym mogą pobrać tylko swój dzień.",
  "+ Set a different replay price after the event (optional)": "+ Ustaw inną cenę nagrania po wydarzeniu (opcjonalnie)",
  "Replay price after the event": "Cena nagrania po wydarzeniu",
  "Use ticket price": "Użyj ceny biletu",
  "Once the event is over, new buyers pay this instead of the ticket price. You can also change any price at any time.": "Po zakończeniu wydarzenia nowi kupujący płacą tę kwotę zamiast ceny biletu. Każdą cenę możesz też zmienić w dowolnym momencie.",
  "Add fees at checkout (buyers pay the fees)": "Doliczaj opłaty przy płatności (płacą je kupujący)",
  "Buyers pay one combined EventLive + card processing fee on top of your price, so you receive the full amount you set (card fees are estimated at the standard rate — unusual cards may vary slightly).": "Kupujący płacą do twojej ceny jedną łączną opłatę EventLive i za obsługę karty, więc otrzymujesz pełną ustaloną kwotę (opłaty za kartę są szacowane według standardowej stawki — przy nietypowych kartach mogą się nieznacznie różnić).",
  "Fees are currently deducted from your price: the EventLive fee shown above plus Stripe's card processing fee.": "Obecnie opłaty są potrącane z twojej ceny: opłata EventLive widoczna powyżej oraz opłata Stripe za obsługę karty.",
  "Default Price Suggestions": "Sugerowane kwoty",
  "These are suggested amounts customers will see, but they can enter any amount they wish.": "To sugerowane kwoty, które zobaczą klienci, ale mogą wpisać dowolną kwotę.",
  "More settings": "Więcej ustawień",
  "Upload logo in Profile Settings": "Prześlij logo w ustawieniach profilu",
  "Invite free viewers in Guest List": "Zaproś widzów za darmo z listy gości",
  "Customize event branding": "Dostosuj branding wydarzenia",
  "Enable payment emails in Stripe": "Włącz e-maile o płatnościach w Stripe",
  "Customize branding in Stripe": "Dostosuj branding w Stripe",
  "Credits Added Successfully": "Dodano kredyty",
  "Thank You for Your Purchase!": "Dziękujemy za zakup!",
  "Your credits are ready to use. You can now:": "Twoje kredyty są gotowe do użycia. Teraz możesz:",
  "You can now:": "Teraz możesz:",
  "Use your credits to unlock more events": "Wykorzystać kredyty do odblokowania kolejnych wydarzeń",
  "Check your available balance before your next purchase": "Sprawdzić dostępne saldo przed kolejnym zakupem",
  "Return to your events and keep editing": "Wrócić do swoich wydarzeń i dalej je edytować",
  "Invite guests to your event by sharing the event link or using the Guest List feature": "Zaprosić gości, udostępniając link do wydarzenia lub korzystając z listy gości",
  "Open \"How to Go Live\" for a step-by-step guide": "Otworzyć „Jak rozpocząć transmisję”, aby zobaczyć instrukcję krok po kroku",
  "Go live on the day of your event": "Rozpocząć transmisję w dniu wydarzenia",
  "Return to Event": "Wróć do wydarzenia",
  "View My Events": "Zobacz moje wydarzenia",
  "Afghanistan": "Afganistan",
  "Åland Islands": "Wyspy Alandzkie",
  "Albania": "Albania",
  "Algeria": "Algieria",
  "American Samoa": "Samoa Amerykańskie",
  "Andorra": "Andora",
  "Angola": "Angola",
  "Anguilla": "Anguilla",
  "Antarctica": "Antarktyda",
  "Antigua and Barbuda": "Antigua i Barbuda",
  "Argentina": "Argentyna",
  "Armenia": "Armenia",
  "Aruba": "Aruba",
  "Australia": "Australia",
  "Austria": "Austria",
  "Azerbaijan": "Azerbejdżan",
  "Bahamas": "Bahamy",
  "Bahrain": "Bahrajn",
  "Bangladesh": "Bangladesz",
  "Belgium": "Belgia",
  "Belize": "Belize",
  "Benin": "Benin",
  "Bermuda": "Bermudy",
  "Bhutan": "Bhutan",
  "Bolivia": "Boliwia",
  "Bosnia and Herzegovina": "Bośnia i Hercegowina",
  "Botswana": "Botswana",
  "Bouvet Island": "Wyspa Bouveta",
  "Brazil": "Brazylia",
  "British Indian Ocean Territory": "Brytyjskie Terytorium Oceanu Indyjskiego",
  "Brunei Darussalam": "Brunei",
  "Bulgaria": "Bułgaria",
  "Burkina Faso": "Burkina Faso",
  "Burundi": "Burundi",
  "Cambodia": "Kambodża",
  "Cameroon": "Kamerun",
  "Canada": "Kanada",
  "Cape Verde": "Republika Zielonego Przylądka",
  "Cayman Islands": "Kajmany",
  "Central African Republic": "Republika Środkowoafrykańska",
  "Chad": "Czad",
  "Chile": "Chile",
  "China": "Chiny",
  "Christmas Island": "Wyspa Bożego Narodzenia",
  "Cocos (Keeling) Islands": "Wyspy Kokosowe",
  "Colombia": "Kolumbia",
  "Comoros": "Komory",
  "Congo": "Kongo",
  "Congo, The Democratic Republic of the": "Demokratyczna Republika Konga",
  "Cook Islands": "Wyspy Cooka",
  "Costa Rica": "Kostaryka",
  "Cote D Ivoire": "Côte d’Ivoire",
  "Croatia": "Chorwacja",
  "Cuba": "Kuba",
  "Cyprus": "Cypr",
  "Czech Republic": "Czechy",
  "Denmark": "Dania",
  "Djibouti": "Dżibuti",
  "Dominica": "Dominika",
  "Dominican Republic": "Dominikana",
  "Ecuador": "Ekwador",
  "Egypt": "Egipt",
  "El Salvador": "Salwador",
  "Equatorial Guinea": "Gwinea Równikowa",
  "Eritrea": "Erytrea",
  "Estonia": "Estonia",
  "Ethiopia": "Etiopia",
  "Falkland Islands (Malvinas)": "Falklandy",
  "Faroe Islands": "Wyspy Owcze",
  "Fiji": "Fidżi",
  "Finland": "Finlandia",
  "France": "Francja",
  "French Guiana": "Gujana Francuska",
  "French Polynesia": "Polinezja Francuska",
  "French Southern Territories": "Francuskie Terytoria Południowe i Antarktyczne",
  "Gabon": "Gabon",
  "Gambia": "Gambia",
  "Georgia": "Gruzja",
  "Germany": "Niemcy",
  "Ghana": "Ghana",
  "Gibraltar": "Gibraltar",
  "Greece": "Grecja",
  "Greenland": "Grenlandia",
  "Grenada": "Grenada",
  "Guadeloupe": "Gwadelupa",
  "Guam": "Guam",
  "Guatemala": "Gwatemala",
  "Guernsey": "Guernsey",
  "Guinea": "Gwinea",
  "Guinea-Bissau": "Gwinea Bissau",
  "Guyana": "Gujana",
  "Haiti": "Haiti",
  "Heard Island and Mcdonald Islands": "Wyspy Heard i McDonalda",
  "Holy See (Vatican City State)": "Watykan",
  "Honduras": "Honduras",
  "Hong Kong": "Hongkong",
  "Hungary": "Węgry",
  "Iceland": "Islandia",
  "India": "Indie",
  "Indonesia": "Indonezja",
  "Iran, Islamic Republic Of": "Iran",
  "Iraq": "Irak",
  "Ireland": "Irlandia",
  "Isle of Man": "Wyspa Man",
  "Israel": "Izrael",
  "Italy": "Włochy",
  "Jamaica": "Jamajka",
  "Japan": "Japonia",
  "Jersey": "Jersey",
  "Jordan": "Jordania",
  "Kazakhstan": "Kazachstan",
  "Kenya": "Kenia",
  "Kiribati": "Kiribati",
  "Korea, Democratic People Republic of": "Korea Północna",
  "Korea, Republic of": "Korea Południowa",
  "Kuwait": "Kuwejt",
  "Kyrgyzstan": "Kirgistan",
  "Lao People Democratic Republic": "Laos",
  "Latvia": "Łotwa",
  "Lebanon": "Liban",
  "Lesotho": "Lesotho",
  "Liberia": "Liberia",
  "Libyan Arab Jamahiriya": "Libia",
  "Liechtenstein": "Liechtenstein",
  "Lithuania": "Litwa",
  "Luxembourg": "Luksemburg",
  "Macao": "Makau",
  "Macedonia, The Former Yugoslav Republic of": "Macedonia Północna",
  "Madagascar": "Madagaskar",
  "Malawi": "Malawi",
  "Malaysia": "Malezja",
  "Maldives": "Malediwy",
  "Mali": "Mali",
  "Malta": "Malta",
  "Marshall Islands": "Wyspy Marshalla",
  "Martinique": "Martynika",
  "Mauritania": "Mauretania",
  "Mauritius": "Mauritius",
  "Mayotte": "Majotta",
  "Mexico": "Meksyk",
  "Micronesia, Federated States of": "Mikronezja",
  "Moldova, Republic of": "Mołdawia",
  "Monaco": "Monako",
  "Mongolia": "Mongolia",
  "Montserrat": "Montserrat",
  "Morocco": "Maroko",
  "Mozambique": "Mozambik",
  "Myanmar": "Mjanma (Birma)",
  "Namibia": "Namibia",
  "Nauru": "Nauru",
  "Nepal": "Nepal",
  "Netherlands": "Holandia",
  "Netherlands Antilles": "Antyle Holenderskie",
  "New Caledonia": "Nowa Kaledonia",
  "New Zealand": "Nowa Zelandia",
  "Nicaragua": "Nikaragua",
  "Niger": "Niger",
  "Nigeria": "Nigeria",
  "Niue": "Niue",
  "Norfolk Island": "Norfolk",
  "Northern Mariana Islands": "Mariany Północne",
  "Norway": "Norwegia",
  "Oman": "Oman",
  "Pakistan": "Pakistan",
  "Palau": "Palau",
  "Palestinian Territory, Occupied": "Palestyna",
  "Panama": "Panama",
  "Papua New Guinea": "Papua-Nowa Gwinea",
  "Paraguay": "Paragwaj",
  "Peru": "Peru",
  "Philippines": "Filipiny",
  "Pitcairn": "Pitcairn",
  "Poland": "Polska",
  "Portugal": "Portugalia",
  "Puerto Rico": "Portoryko",
  "Qatar": "Katar",
  "Reunion": "Reunion",
  "Romania": "Rumunia",
  "Russian Federation": "Rosja",
  "RWANDA": "Rwanda",
  "Saint Helena": "Wyspa Świętej Heleny",
  "Saint Kitts and Nevis": "Saint Kitts i Nevis",
  "Saint Lucia": "Saint Lucia",
  "Saint Pierre and Miquelon": "Saint-Pierre i Miquelon",
  "Saint Vincent and the Grenadines": "Saint Vincent i Grenadyny",
  "Samoa": "Samoa",
  "San Marino": "San Marino",
  "Sao Tome and Principe": "Wyspy Świętego Tomasza i Książęca",
  "Saudi Arabia": "Arabia Saudyjska",
  "Senegal": "Senegal",
  "Serbia and Montenegro": "Serbia i Czarnogóra",
  "Seychelles": "Seszele",
  "Sierra Leone": "Sierra Leone",
  "Singapore": "Singapur",
  "Slovakia": "Słowacja",
  "Slovenia": "Słowenia",
  "Solomon Islands": "Wyspy Salomona",
  "Somalia": "Somalia",
  "South Africa": "Republika Południowej Afryki",
  "South Georgia and the South Sandwich Islands": "Georgia Południowa i Sandwich Południowy",
  "Spain": "Hiszpania",
  "Sri Lanka": "Sri Lanka",
  "Sudan": "Sudan",
  "Suriname": "Surinam",
  "Svalbard and Jan Mayen": "Svalbard i Jan Mayen",
  "Swaziland": "Eswatini",
  "Sweden": "Szwecja",
  "Switzerland": "Szwajcaria",
  "Syrian Arab Republic": "Syria",
  "Taiwan, Province of China": "Tajwan",
  "Tajikistan": "Tadżykistan",
  "Tanzania, United Republic of": "Tanzania",
  "Thailand": "Tajlandia",
  "Timor-Leste": "Timor Wschodni",
  "Togo": "Togo",
  "Tokelau": "Tokelau",
  "Tonga": "Tonga",
  "Trinidad and Tobago": "Trynidad i Tobago",
  "Tunisia": "Tunezja",
  "Turkey": "Turcja",
  "Turkmenistan": "Turkmenistan",
  "Turks and Caicos Islands": "Turks i Caicos",
  "Tuvalu": "Tuvalu",
  "Uganda": "Uganda",
  "Ukraine": "Ukraina",
  "United Arab Emirates": "Zjednoczone Emiraty Arabskie",
  "United Kingdom": "Wielka Brytania",
  "United States": "Stany Zjednoczone",
  "United States Minor Outlying Islands": "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
  "Uruguay": "Urugwaj",
  "Uzbekistan": "Uzbekistan",
  "Vanuatu": "Vanuatu",
  "Venezuela": "Wenezuela",
  "Viet Nam": "Wietnam",
  "Virgin Islands, British": "Brytyjskie Wyspy Dziewicze",
  "Virgin Islands, U.S.": "Wyspy Dziewicze Stanów Zjednoczonych",
  "Wallis and Futuna": "Wallis i Futuna",
  "Western Sahara": "Sahara Zachodnia",
  "Yemen": "Jemen",
  "Zambia": "Zambia",
  "Zimbabwe": "Zimbabwe",
  "Your client's account · used for {count} event": {
    "one": "Konto twojego klienta · używane w {count} wydarzeniu",
    "few": "Konto twojego klienta · używane w {count} wydarzeniach",
    "many": "Konto twojego klienta · używane w {count} wydarzeniach"
  },
  "Your client's account": "Konto twojego klienta",
  "Your account · used for {count} event": {
    "one": "Twoje konto · używane w {count} wydarzeniu",
    "few": "Twoje konto · używane w {count} wydarzeniach",
    "many": "Twoje konto · używane w {count} wydarzeniach"
  },
  "Your account": "Twoje konto",
  "Used for {count} event": {
    "one": "Używane w {count} wydarzeniu",
    "few": "Używane w {count} wydarzeniach",
    "many": "Używane w {count} wydarzeniach"
  },
  "Connected before": "Połączone wcześniej",
  "Ticket payouts for “{event}” will go to {account}, your client's Stripe account. Use it only for this client's events.": "Wypłaty za bilety na „{event}” trafią na konto {account} – konto Stripe twojego klienta. Używaj go tylko do wydarzeń tego klienta.",
  "Ticket payouts for “{event}” will go to {account}.": "Wypłaty za bilety na „{event}” trafią na konto {account}.",
  "Use this account": "Użyj tego konta",
  "Couldn't use this Stripe account": "Nie udało się użyć tego konta Stripe",
  "Use a Stripe account you've connected before": "Użyj wcześniej połączonego konta Stripe",
  "Or connect another Stripe account:": "Albo połącz inne konto Stripe:",
  "Connect another Stripe account": "Połącz inne konto Stripe"
}
